import { useEffect, useState } from 'react'
import { Progress } from 'antd'

import Box from '~/core/Box'
import getColor from '~/lib/getColor'

const CloneQuoteProgress = () => {
    const [seconds, setSeconds] = useState<number>(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(seconds + 1)
        }, 45)

        return () => clearInterval(interval)
    }, [seconds])

    return (
        <Box>
            <Progress
                percent={seconds}
                type="line"
                strokeColor={getColor('success')}
            />
        </Box>
    )
}

export default CloneQuoteProgress
